/**
 * SearchPageV2 — redesigned shell for the in-app search
 * configuration page. Mirrors the v1 layout (Top Search + Suggested
 * Searches side-by-side, then Search Deeplinks below) but wraps each
 * section in V2 surface chrome.
 *
 * Each sub-section is its own V2 component built on brand primitives
 * (TextInput / Select / UploadTile / Button / IconButton) with
 * @dnd-kit sortable rows for the two list editors. The v1 MUI
 * versions are still available behind the redesign flag via
 * SearchPageSwitch.
 */
import React from 'react';
import SuggestedSearchesV2 from './SuggestedSearchesV2';
import TopSearchV2 from './TopSearchV2';
import SearchDeeplinksV2 from './SearchDeeplinksV2';
import { PageHeader } from '../../redesign';

/* V2 surface card with an Asap-Condensed eyebrow header. Local to
 * this page; the AppUser equivalent (V2CardWrap) carries an
 * optional icon slot that we don't need here. */
function SectionCard({ title, children }) {
  return (
    <section
      className="bg-surface border border-sand"
      style={{ borderRadius: 12, padding: 18, overflow: 'hidden' }}
    >
      <div
        className="font-condensed font-bold uppercase text-text-muted"
        style={{ fontSize: 11, letterSpacing: '0.08em', marginBottom: 12 }}
      >
        {title}
      </div>
      {children}
    </section>
  );
}

export default function SearchPageV2() {
  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Assets"
        title="Search"
      />

      <div style={{ padding: '0 28px 60px', display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* Two-column row: Top Search (narrower) + Suggested
         *  Searches (wider) — matches v1's 1fr 2fr split. */}
        <div
          className="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]"
          style={{ gap: 16 }}
        >
          <SectionCard title="Top Search">
            <TopSearchV2 />
          </SectionCard>
          <SectionCard title="Suggested searches">
            <SuggestedSearchesV2 />
          </SectionCard>
        </div>

        <SectionCard title="Search results deeplinks">
          <SearchDeeplinksV2 />
        </SectionCard>
      </div>
    </div>
  );
}
